<template>
  <div class="machines-index d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="models"
      :filtersValue="{}"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :externalFilters="externalFilters"
    ></filtered-data>

    <div class="container-fluid d-flex">
      <h1>Модели автоматов</h1>
      <button class="btn btn-primary ml-auto mr-2 my-2" @click="openModal()">Добавить модель</button>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @filter-change="filterChange"
      >
        <el-table-column prop="name" label="Наименование модели"></el-table-column>
        <el-table-column prop="type.name" label="Тип автомата"></el-table-column>
        <el-table-column prop="components_count" label="Количество ингредиентов" align="center"></el-table-column>
        <el-table-column  v-if="$root.isAdmin()" prop="region.short_name" label="Организация"
                          :filters="regionFilters"
                          column-key="region_id"
                          filter-placement="bottom-start"/>
        <el-table-column align="right">
          <template slot-scope="{row, $index}">
            <router-link
              class="btn btn-sm btn-outline-light mr-1"
              v-if="row.components_count"
              :to="`/admin/models/${row.id}`"
              title="Редактировать максимальную загрузку"
            >Редактировать</router-link>
            <btn-action
              class="btn btn-sm btn-outline-danger"
              @click="removeModel(row, $index)"
            >Удалить</btn-action>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import ModelModal from '../../../components/model-modal.vue'
  import BtnAction from '../../../components/btn-action'
  import api from '@/api'

  export default {
    components: {BtnAction},
    metaInfo: {title: 'Модели автоматов'},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
        regionFilters: [],
        externalFilters: null,
      }
    },
    methods: {
      openModal () {
        this.$root.showModal(ModelModal)
      },
      removeModel (model, index) {
        if (!window.confirm('Действительно удалить модель?')) return null
        return api.delete(`models/${model.id}`)
          .then((data) => {
            this.data.data.splice(index, 1)
          })
      },
      filterChange (filter) {
        this.externalFilters = filter
      },
    },
    asyncComputed: {
      filters () {
        if (this.$root.isAdmin()) {
          api.get('regions/options', {
            params: {field: 'short_name'},
          }).then(data => {
            this.regionFilters = data.data.data.map((el) => {
              return {
                value: el.id,
                text: el.short_name,
              }
            })
          })
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/models/index.vue